var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex items-center flex-column justify-content-center"},[_c('span',{staticClass:"loader"}),_c('p',{staticClass:"text-center text-sm font-weight-normal"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }